import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"
import { ExistingPlanOptions } from "../../../types"

const NEED_OVERWRITE_MODE = "NEED_OVERWRITE_MODE"
const ZERO_INSTRUCTIONAL_TIME =
  "You cannot save a study plan with 0 hours of instructional time."

export const saveStudyPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "activatePlan",
    src: "activatePlan",
    onDone: [
      {
        // maybe make it get_study_plans_transition then have that transition to see if previousParent === "save" and if so go to study_plans_overview
        target: "#StudyPlan.study_plans_overview",
        actions: assign<Context>({
          studyPlan: null,
          studyPlansListBySubjects: null, // reset this to loading all plans including the newly saved plan
          seconds: null,
          existingPlanOption: ExistingPlanOptions.NOTSET,
          snackbar: (_ctx, _evt) => ({
            message: "Study Plan saved.",
            withUndo: false,
            variant: "success"
          })
        }),
        cond: (ctx, _evt) =>
          ctx.selfRefScope.scope === "DISTRICT" ||
          ctx.selfRefScope.scope === "SCHOOL"
      },
      {
        target: "#StudyPlan.teacher_view",
        actions: assign<Context>({
          studyPlan: null,
          studyPlansListBySubjects: null, // reset this to loading all plans including the newly saved plan
          seconds: null,
          existingPlanOption: ExistingPlanOptions.NOTSET,
          snackbar: (_ctx, _evt) => ({
            message: "Study Plan saved.",
            withUndo: false,
            variant: "success"
          })
        }),
        cond: (ctx, _evt) => ctx.selfRefScope.scope === "TEACHER"
      }
    ],
    onError: [
      {
        // Stay on edit_plan page so user can modify hours.
        target: "#StudyPlan.edit_plan.idle",
        cond: (_ctx, evt) => evt.data?.message === ZERO_INSTRUCTIONAL_TIME,
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, evt) => ({
            message: evt.data,
            withUndo: false,
            variant: "warning"
          })
        })
      },
      {
        target: "#StudyPlan.study_plans_overview",
        cond: (_ctx, evt) =>
          evt.data.extension?.[0]?.code !== NEED_OVERWRITE_MODE,
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("activatePlan", {
              errorReason: evt.data.message
            }), //
            withUndo: false,
            error: true
          })
        })
      },
      {
        target: "confirm_override",
        cond: (_ctx, evt) =>
          evt.data.extension?.[0]?.code === NEED_OVERWRITE_MODE,
        actions: assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => {
          const { affectedPlansCounts } = evt.data.extension?.[0] || {}

          return {
            overrideSchoolsCount: affectedPlansCounts?.["SCHOOL"] ?? 0,
            overrideTeachersCount: affectedPlansCounts?.["TEACHER"] ?? 0,
            overrideClassesCount: affectedPlansCounts?.["CLASS"] ?? 0
          }
        })
      }
    ]
  }
}
